<template>
    <div class="third service-classify-type">
	    <div class="third-rea">
            <div class="third-btn">
                <div class="btn-left">检索条件</div>
                <div class="btn-right">
                    <el-button class="btn-two" type="primary" @click="searchHeader">查询</el-button>
                    <el-button class="btn-two" type="default" @click="reset">重置</el-button>
                </div>
            </div>
            <div class="third-search">
                <el-form :inline="true" :model="searchForm" label-width="76px">
                    <div class="search-row">
                        <div class="row-item">
                            <el-form-item label="类型名称">
                                <el-input
                                    class="item-input"
                                    :maxlength="30"
                                    v-model.trim="searchForm.content"
                                    placeholder="请输入"
                                    @keyup.enter.native="searchHeader">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
		</div>
		<div class="third-one">
            <div class="third-do-btn">
                <el-button class="do-btn-four" type="default" icon="el-icon-plus" @click="openAddNewTypeModal">新增</el-button>
            </div>
            <div>
                <el-table
                    class="third-tableThree"
                    :data="tableData"
                    border
                    stripe
                    v-loading="tableLoading"
                    ref="otherTableBasic"
                    row-key="otherUserId">
                    <template v-for="(val,key) in tableDataShow">
                        <el-table-column
                            v-if="val.needKeyValue"
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <key-value-span :value="scope.row[val.key]" :dictUrl="val.actionUrl"></key-value-span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-else
                            min-width="100px"
                            :prop="val.key"
                            :label="val.column"
                            :key="key"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                    </template>
                    <el-table-column label="操作">
                        <template slot-scope="{row}">
                            <el-button @click="openEditTypeModal(row)" type="text" size="small" :disabled="row.is_internal === 1">编辑</el-button>
                            <span class="table-middle_line"></span>
                            <el-button type="text" size="small" @click="deleteItem(row)" :disabled="row.is_internal === 1">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="third-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        background
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
            <!-- <fm-grid url="/api/blade-platform/serviceType/list" ref="serviceClassifyTypeTable">
                <template slot-scope="{rows,loading}">
                </template>
            </fm-grid> -->
		</div>
		<hign-modal :hignModalVisible="hignModal" @cancelModal="closeModal"></hign-modal>
        <new-notice-modal
            noticeTitle="提示"
            :noticeModalVisible="deleteNoticeDialog"
            noticeSpec="类型下的服务将移动至“其他类型”，"
            noticeContent="确定删除吗？"
            @closeNewTask="closeDeleteNoticeDialog">
			<template v-slot:footer>
				<el-button class="modal-footer-two" @click="closeDeleteNoticeDialog">取消</el-button>
				<el-button class="modal-footer-two" type="primary" @click="confirmDeleteType">确定</el-button>
			</template>
		</new-notice-modal>
        <el-dialog
            class="addNewTypeModalClass"
            :title="typeModalTitle"
            width="592px"
            v-el-drag-dialog
            :close-on-click-modal="false"
            :visible.sync="addNewTypeModal"
            :before-close="handleCloseTypeModal">
            <div class="">
                <el-form :model="typeForm" :rules="typeFormRules" ref="typeForm" label-width="100px" class="demo-ruleForm" @validate="validateTwo" :show-message="false">
                    <el-form-item label="类型名称：" prop="name">
                        <el-input class="list-input" :maxlength="6" placeholder="请输入" v-model="typeForm.name" style="width:200px;"></el-input>
                    </el-form-item>
                    <el-form-item label="类型排序：" prop="order">
                        <!-- <el-input class="list-input" :maxlength="4" placeholder="请输入类型排序" v-model="typeForm.order" style="width:200px;"></el-input> -->
                        <el-input-number class="list-input" v-model="typeForm.order" :min="1" :max="9999" step-strictly placeholder="请输入正整数" :controls="false" style="width:200px;"></el-input-number>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseTypeModal">取 消</el-button>
                <el-button type="primary" v-el-disabel-repeat-click @click="typeFormSubmit">保 存</el-button>
            </span>
        </el-dialog>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { setStore, getStore } from "@/utils/store";
import { cloneDeep } from "lodash";
// import { eduotheruserinfoRemovePort } from "@/api/c1.2/other.js";
export default {
    name: "thirdThree",
	data() {
		return {
            tableLoading: false,
            checkID: '',
            isIndeterminate: true,
            outputModal: false, // 导出弹窗
            isJS: true, //是否有检索条件
            detailModal: false, // 详情弹窗
            isError: true, // 是否是错误提示
            noticeSpec: '', // 标红提示
            ruleFormImport: {
                jbDesc: '',
                fileList: [], // 文件列表
                gzRadio: '', // 重复规则
                fieldGroup: [] // 检查字段
            },
            importModal: false, // 导入弹窗
            fieldsModal: false, // 字段显示弹窗
            pageSize: 40,
            currentPage: 1,
            total: 0,
            tableData: [],
            hignModal: false, // 高级搜索
            searchForm: {
                content: '', // 内容
            },
            deleteNoticeDialog: false, // 提示弹窗
            noticeType: 1, // 提示类型
            noitceContent: "是否确认删除？", // 提示信息
            noticeTitle: "确认操作", // 提示
            deleteRow: {}, // 单个删除行
            deleteList: [], // 多行删除
            keyIdList: [],
            type: "single",
            orderConfig: '', // 顺序设置
            tableDataShow: [], // 表格行设置
            hignSearchRes: '', // 高级检索条件
            tableRow: [
                {
                    column: "类型名称",
                    key: "name",
                    needKeyValue: false,
                    caseKey: "name"
                },
                {
                    column: "排序",
                    key: "sort",
                    needKeyValue: false,
                    caseKey: "sort"
                },
                {
                    column: "服务个数",
                    key: "servise_num",
                    needKeyValue: false,
                    caseKey: "serviseNum"
                },
                {
                    column: "更新时间",
                    key: "update_time",
                    needKeyValue: false,
                    caseKey: "updateTime"
                },
            ],
            addNewTypeModal: false,
            selectReasonList: [],
            typeForm: {
                id: '',
                name: '',
                order: '',
            },
            typeFormRules: {
                name: [
                    { required: true, message: '请输入类型名称', trigger: 'blur' }
                ],
                order: [
                    { required: true, message: '请输入类型排序', trigger: 'blur' },
                    // { validator: validateOrder, trigger: 'blur' },
                ],
            },
            confirmCancelShieldModal: false,
            typeModalTitle: '',
            countNum: 1, // 只显示第一条错误信息
            deleteRowData: '',
		};
	},
	created() {
		const dispField = this.getSessonValue("otherDisplayFied");
		const tableRow = this.getSessonValue("otherSortData");
		if (dispField) {
		    this.orderConfig = dispField;
		}
		if (tableRow) {
		    this.tableDataShow = tableRow;
		} else {
		    this.tableDataShow = this.tableRow;
		}
	},
	mounted() {
		this.searchHeader();
	},
	computed: {
		...mapState({
            componentsName: state => state.serviceClassifyType.serviceClassifyTypeComponentName,
        })
	},
	methods: {
        ...mapActions([
            'getServiceTypeList',
            'getServiceTypeSubmit',
            'getServiceTypeRemove',
        ]),
        ...mapMutations({
            changeComponentName: "SET_serviceClassifyTypeComponentName"
        }),
        // 验证
        validateTwo(prop, msgStatus, validateMessage) {
            // console.log(prop, msgStatus, validateMessage)
            if (!msgStatus && !this.countNum) {
                this.countNum += 1;
                if (validateMessage) {
                    this.$message.error(validateMessage)
                }
            }
        },
        // 确认新增/ 修改
        typeFormSubmit() {
            this.countNum = 0;
            // this.addNewTypeModal = false;
            this.$refs['typeForm'].validate((valid) => {
                if (valid) {
                    this.sureSubmit()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async sureSubmit() {
            const {
                data: { msg, status }
            } = await this.getServiceTypeSubmit({
                id: this.typeForm.id,
                name: this.typeForm.name,
                sort: this.typeForm.order,
            })
            this.tableLoading = false
            if (status === 1000) {
                this.$message.success('操作成功！')
                this.handleCloseTypeModal()
                this.search()
                return
            }
            this.$message.error(msg);
        },
		// 打开新增弹窗
		openAddNewTypeModal() {
            this.addNewTypeModal = true;
            this.typeModalTitle = '新增服务类型'
            this.typeForm.id = ''
        },
        handleCloseTypeModal() {
            this.$refs['typeForm'].resetFields();
            this.typeForm.id = ''
            this.typeForm.name = ''
            this.typeForm.order = ''
            this.addNewTypeModal = false;
        },
        openEditTypeModal(data) {
            this.typeModalTitle = '编辑服务类型'
            this.typeForm.id = data.id
            this.typeForm.name = data.name
            this.typeForm.order = data.sort
            this.addNewTypeModal = true;
        },
        // 确认删除
        async confirmDeleteType() {
            const {
                data: { msg, status }
            } = await this.getServiceTypeRemove({
                ids: this.deleteRowData.id
            })
            if (status === 1000) {
                this.$message.success('操作成功！');
                this.closeDeleteNoticeDialog()
                this.search()
                return
            }
            this.$message.error(msg);
        },
        closeDeleteNoticeDialog() {
            this.deleteNoticeDialog = false;
        },
		getSessonValue(name) {
            return getStore({
                name: name,
                type: "session"
            });
		},
		reset() {
            this.currentPage = 1;
            Object.assign(this.searchForm, this.$options.data().searchForm);
            this.hignSearchRes = ''
            this.search();
        },
        searchHeader() {
            this.currentPage = 1;
            this.search();
        },
		async search() {
            this.tableLoading = true
            this.searchForm.content = this.searchForm.content.trim()
            const {
                data: { result, msg, status }
            } = await this.getServiceTypeList({
                typeName: this.searchForm.content,
                pageIndex: this.currentPage,
                pageSize: this.pageSize,
            })
            this.tableLoading = false
            console.log(result)
            if (status === 1000) {
                if (result.data.length !== 0) {
                    this.tableData = result.data
                    this.total = Number(result.total)
                } else {
                    if (this.currentPage !== 1) {
                        this.currentPage -= 1
                        this.search()
                    } else {
                        this.tableData = []
                        this.total = 0
                    }
                }
                return
            }
            this.tableData = []
            this.total = 0
            this.$message.error(msg);
		},
		changeComponent(rowData) {
            setStore({
                name: "rowData",
                content: rowData,
                type: "session"
            });
            this.$emit("changeComponent", "DetailsInfo");
		},
		// 删除
		deleteItem(data) {
            this.deleteRowData = data
		    this.deleteNoticeDialog = true;
		},
		// 关闭弹窗
		closeModal() {
		    this.hignModal = false;
        },
        //条数变化
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.search();
        },
        //页码变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search();
        },
	}
};
</script>
<style lang="scss">
.service-classify-type {
	.third-tableThree {
		.el-table__body-wrapper {
			height: calc(100vh - 197px) !important;
		}
	}
    .addNewTypeModalClass {
        .el-input-number .el-input__inner {
            text-align: left;
        }
        .el-dialog__header {
            // border-bottom: 1px solid #D4D4D7;
            padding: 11px 16px;
            line-height: normal;
            .el-dialog__headerbtn {
                top: 11px;
                right: 16px;
            }
            .task-modal-title {
                .modal-title-icon {
                    font-size: 18px;
                }
                .modal-title-span {
                    font-size: 18px;
                    color: #2E4057;
                    font-weight: bold;
                }
            }
        }
        .el-dialog__body {
            // height: 276px;
            padding: 16px;
            // text-align: center;
            // overflow-y: auto;
            font-size: 14px!important;
            .el-form-item {
                display: block;
                // margin-bottom: 8px;
            }
        }
        .el-dialog__footer {
            // border-top: 1px solid #D4D4D7;
            padding: 16px;
            line-height: normal;
            .task-modal-footer {
                font-size: 0;
                .el-button {
                    // padding: 0 !important;
                    margin-left: 8px !important;
                }
                .modal-footer-two {
                    // width: 48px;
                    height: 28px;
                }
                .modal-footer-four {
                    // width: 72px;
                    height: 28px;
                }
            }
        }
    }
}
</style>
